import React, { useRef } from "react";
import { Button } from "semantic-ui-react";
import Modal from "components/modal";
import ContactList from "components/Picker/ContactPicker/ContactList";

interface Props {
  onContactLinked: (contactId: number) => void
}

const LinkExistingContact = (props: Props) => {
  const [isLinking, setIsLinking] = React.useState(false);
  const ref = useRef<Button>(null);

  const onContactSelected = (contact: server.dto.ContactSmallV2) => {
    props.onContactLinked(contact.contactId);
    setIsLinking(false);
  };

  const handleClose = () => {
    setIsLinking(false);
    ref.current?.focus();
  }

  return <>
    <Button
      ref={ref}
      className="blue"
      style={{ marginBottom: 2 }}
      onClick={() => { setIsLinking(true); }}
      fluid
      type="button"
    >
      {RESX.Contact.LinkExistingContact}
    </Button>

    <Modal
      isOpen={isLinking}
      handleClose={handleClose}
      size="mini"
      gap="regular"
      minHeight={400}
      title={RESX.Contact.LinkExistingContact}
    >
      <ContactList
        onItemSelected={onContactSelected}
      />
    </Modal>
  </>;
};

export default LinkExistingContact;